<template>
  <el-dialog
    class="hx-choose-dialog"
    width="1039px"
    center
    v-bind="$attrs"
    v-on="$listeners"
    @open="initData"
  >
    <div>
      <div v-if="searchFormData !== null">
        <el-form
          ref="SearchForm"
          label-position="right"
          label-width="100px"
          size="mini"
          :inline="true"
          :model="searchFormData"
        >
          <slot></slot>
        </el-form>
      </div>

      <el-row
        style="margin: 16px 0;"
        v-if="searchFormData !== null && !hideSearchButtons"
      >
        <el-col :span="24" style="text-align: right">
          <el-button size="medium" type="primary" @click="search(true)">
            搜索
          </el-button>
          <el-button size="medium" @click="resetForm">清空</el-button>
        </el-col>
      </el-row>

      <HxTable
        ref="table"
        v-loading="tableLoading"
        default-column-width="150"
        max-height="300"
        height="300"
        show-index-col
        :show-selection-col="multiple"
        :data="tableData"
        :columns="customTableColumn"
        :selectable="
          (row, index) => {
            if (selectable) {
              return selectable(row, index, selectionAll)
            }

            return true
          }
        "
        v-bind="tableProps"
        @select="handleSelectionChange"
        @select-all="handleSelectionAll"
      >
        <template v-if="!multiple && showSingleRadio" #singleRadio="{ row }">
          <el-radio
            :value="singleSelectedKey"
            :label="row[rowKey]"
            @change="handleSinglePick(row)"
          >
            &nbsp;
          </el-radio>
        </template>
        <template v-if="!multiple" #action="{ row, $index }">
          <el-button type="text" size="mini" @click="handleSelect(row, $index)">
            {{ actionText }}
          </el-button>
        </template>
      </HxTable>

      <HxPagination
        :page.sync="paginationData.pageNum"
        :limit.sync="paginationData.limit"
        :total="paginationData.total ?? 0"
        @pagination="handlePagination"
      />

      <div v-if="multiple" class="confirm-box">
        <p class="confirm-l">已选中{{ selectionAll.length }}个</p>
        <div class="confirm-r">
          <el-button type="primary" size="small" @click="handleConfirm">
            确认
          </el-button>
          <el-button size="small" @click="$emit('update:visible', false)">
            取消
          </el-button>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import request from '@/utils/requestv2'
import requestv3 from '@/utils/requestv3'

export default {
  name: 'HxChooseDialog',

  components: {},

  inheritAttrs: false,

  props: {
    multiple: {
      type: Boolean,
      default: false,
    },
    selectable: Function,
    searchFormData: {
      type: Object,
      default: () => ({}),
    },
    tableColumn: {
      required: true,
      type: Array,
    },
    api: {
      required: true,
      type: String,
    },
    selectedData: {
      type: Array,
      default: () => [],
    },
    rowKey: {
      type: [String, Number],
      default: 'id',
    },
    searchResponse: Function,
    reqBefore: Function,
    clearSearchSel: Boolean,
    tableProps: Object,
    v3: {
      default: false,
      type: Boolean,
    },

    /**
     * HACK(d1y): 临时用法!!!
     * api 接口使用 get 获取
     * !!!暂时不存在所谓分页!!!
     */
    apiUseGetFetch: {
      type: Boolean,
      default: false,
    },
    // 单选模式下是否展示左侧单选按钮列
    showSingleRadio: {
      type: Boolean,
      default: false,
    },
    // 单选模式下操作列是否放到最右侧
    actionColumnAtEnd: {
      type: Boolean,
      default: false,
    },
    // 单选模式下操作按钮文本
    actionText: {
      type: String,
      default: '选择',
    },
    // 隐藏搜索/清空按钮区域
    hideSearchButtons: {
      type: Boolean,
      default: false,
    },
    // 单选模式下隐藏操作列
    hideActionColumn: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      selectionAll: [],
      singleSelectedKey: null,
      tableData: [],
      tableLoading: false,
      paginationData: {
        total: 0,
        pageNum: 0,
        limit: 20,
      },
    }
  },

  computed: {
    customTableColumn() {
      if (this.multiple) {
        return [...this.tableColumn]
      } else {
        const actionColumn = {
          defaultSlot: 'action',
          label: '操作',
          width: 150,
        }
        const singleRadioColumn = {
          defaultSlot: 'singleRadio',
          label: '',
          width: 60,
        }
        const columns = [...this.tableColumn]
        if (!this.hideActionColumn) {
          if (this.actionColumnAtEnd) {
            columns.push(actionColumn)
          } else {
            columns.unshift(actionColumn)
          }
        }
        if (this.showSingleRadio) {
          columns.unshift(singleRadioColumn)
        }
        return columns
      }
    },
  },

  watch: {
    selectedData: {
      immediate: true,
      handler(list) {
        this.selectionAll = [...list]
        this.singleSelectedKey =
          list && list.length > 0 ? list[0]?.[this.rowKey] : null
      },
    },
  },

  created() {},

  methods: {
    resetForm() {
      if (this.$refs.SearchForm) {
        this.$refs.SearchForm.resetFields()
      }
      this.$emit('reset:search', true)
      this.$nextTick(() => {
        this.search(true)
      })
    },
    async search(init) {
      if (init) {
        this.paginationData.pageNum = 0

        if (this.clearSearchSel) {
          this.selectionAll = []
        }
      }

      let reqData = {}
      if (this.searchFormData !== null) {
        reqData = {...this.searchFormData}
      }
      reqData = {
        ...reqData,
        page: this.paginationData.pageNum > 0 ? this.paginationData.pageNum - 1 : 0,
        size: this.paginationData.limit,
      }

      this.tableLoading = true

      const reqConfig = {
        url: this.api,
        method: this.apiUseGetFetch ? 'get' : 'post',
        data: reqData,
        loading: false,
      }

      if (this.reqBefore) {
        this.reqBefore(reqConfig)
      }

      let res

      if (this.v3) {
        res = await requestv3(reqConfig)
      } else {
        res = await request(reqConfig)
      }

      const { data, list, total, records, items } = res.data ? res.data : {}

      let tableData = data || list || records || items || []

      if (Array.isArray(res.data)) {
        tableData = res.data
      }

      if ('items' in res && Array.isArray(res.items)) {
        tableData = res.items.map((item) => {
          if ('meta' in item) {
            const meta = item.meta
            Object.keys(meta).forEach((key) => {
              item[key] = meta[key]
            })
          }
          return item
        })
      }

      if (res.data && 'items' in res.data && Array.isArray(res.data.items)) {
        tableData = res.data.items.map((item) => {
          if ('meta' in item) {
            const meta = item.meta
            Object.keys(meta).forEach((key) => {
              item[key] = meta[key]
            })
          }
          return item
        })
      }

      let pageCountTotal = total

      if (typeof this.searchResponse === 'function') {
        const { list, totalCount } = this.searchResponse(res)
        tableData = list
        pageCountTotal = totalCount
      }

      this.tableData = tableData
      this.paginationData.total = pageCountTotal
      this.tableLoading = false

      this.$nextTick(() => {
        this.setSelectedRow()
      })
    },
    handlePagination(data) {
      this.paginationData = { total: this.paginationData.total, ...data }
      this.search()
    },
    initData() {
      this.$emit('initData', this.searchFormData)
      this.selectionAll = [...this.selectedData]
      this.$nextTick(() => {
        this.resetForm()
      })
    },
    handleSelect(row) {
      this.handleSinglePick(row)
      this.$emit('selected', row)
    },
    handleSinglePick(row) {
      if (!row) return
      this.singleSelectedKey = row[this.rowKey]
      this.selectionAll = [{ ...row }]
      this.$emit('single-change', row)
    },
    findItem(item) {
      return this.selectionAll.find((v) => item[this.rowKey] === v[this.rowKey])
    },
    handleSelectionAll(selection) {
      if (selection.length === 0) {
        this.tableData.forEach((item) => {
          const exist = this.findItem(item)
          if (exist) {
            this.selectionAll.splice(this.selectionAll.indexOf(exist), 1)
          }
        })
      } else {
        selection.forEach((item) => {
          const exist = this.findItem(item)
          if (!exist) {
            this.addSelectionAll(item)
          }
        })
      }
    },
    handleSelectionChange(selection, row) {
      const checked = !!selection.find((item) => row === item)
      const exist = this.findItem(row)

      if (exist && !checked) {
        this.selectionAll.splice(this.selectionAll.indexOf(exist), 1)
      }

      if (!exist && checked) {
        this.addSelectionAll(row)
      }
    },
    addSelectionAll(row) {
      let data = { ...row }

      this.selectionAll.push(data)
    },
    setSelectedRow() {
      const rows = this.tableData.filter((item) => {
        return this.findItem(item)
      })

      rows.forEach((row) => {
        this.$refs.table.toggleRowSelection(row)
      })
    },
    handleConfirm() {
      this.$emit('selected', this.selectionAll)
    },
  },
}
</script>
